import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";
import "../styles/Header.css";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigation = (section) => {
    if (location.pathname !== "/") {
      // If not on the Home page, navigate to Home first and pass the scrollTo state
      navigate("/", { state: { scrollTo: section } });
    } else {
      // If already on the Home page
      if (section === "home") {
        // Scroll to the top of the page
        window.scrollTo({ top: 0 });
      } else {
        // Scroll to the specified section
        scroller.scrollTo(section, {
          duration: 500,
        });
      }
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="logo">Zaffron</div>
        <nav className="nav">
          <Link
            to="/"
            onClick={() => handleNavigation("home")}
            className="nav-link"
          >
            Home
          </Link>
          <Link
            to="/"
            onClick={() => handleNavigation("about")}
            className="nav-link"
          >
            About
          </Link>
          <Link
            to="/"
            onClick={() => handleNavigation("skills")}
            className="nav-link"
          >
            Skills
          </Link>
          <Link
            to="/"
            onClick={() => handleNavigation("services")}
            className="nav-link"
          >
            Services
          </Link>
          <Link
            to="/"
            onClick={() => handleNavigation("portfolio")}
            className="nav-link"
          >
            Portfolio
          </Link>
          <Link
            to="/"
            onClick={() => handleNavigation("contact")}
            className="nav-link"
          >
            Contact
          </Link>
          <Link to="/blog" className="nav-link">
            Blog
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
